import React from "react";

const PlusIcon = () => {
    return (
        <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 4H7M3.5 0.5L3.5 7.5" stroke="#646363" />
        </svg>
    );
};

export default PlusIcon;



// WEBPACK FOOTER //
// ./src/components/CollapsibleTable/PlusIcon.tsx